import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { allTools } from '../data/toolsData';

const STORAGE_KEY = 'bytescan-recent-tools';
const MAX_ITEMS = 5;

const validPaths = new Set(allTools.map((t) => t.path));

export function useRecentTools() {
  const location = useLocation();
  const [recentPaths, setRecentPaths] = useState<string[]>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        return JSON.parse(saved);
      }
    } catch {
      // ignore
    }
    return [];
  });

  useEffect(() => {
    const path = location.pathname;
    if (!validPaths.has(path)) return;

    setRecentPaths((prev) => {
      const filtered = prev.filter((p) => p !== path);
      const next = [path, ...filtered].slice(0, MAX_ITEMS);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        // ignore
      }
      return next;
    });
  }, [location.pathname]);

  return recentPaths;
}
